import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cl-angle-down",
  "use": "icon-cl-angle-down-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-cl-angle-down\"><path d=\"M8.753 12.14a1 1 0 0 1-1.506 0L2.451 6.658C1.885 6.013 2.345 5 3.204 5h9.592c.86 0 1.319 1.012.753 1.659l-4.796 5.48Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol